const BRANCH_OFFICE = [
  {
    name: "田村市役所",
    postal: "963-4393",
    address: "福島県田村市船引町船引畑添76-2",
    lat: 37.39963,
    lng: 140.63038
  }
];

export { BRANCH_OFFICE };
